import MuiTableCell from '@mui/material/TableCell';
import type { ReactNode } from 'react';

export interface TableCellProps {
  align?: 'left' | 'right' | 'center';
  component?: 'th' | 'td';
  scope?: string;
  // Keeps the cell's content on one line. Deliberately NOT named `noWrap` like Text's
  // prop, which truncates with an ellipsis: here nothing is ever hidden — a value wider
  // than its column overflows visibly instead of silently breaking mid-value.
  singleLine?: boolean;
  children?: ReactNode;
}

// Table cell behind the facade. `component="th"` + `scope` lets a header cell announce
// itself to assistive tech; the leading icon slot renders an empty cell.
export function TableCell({
  align = 'left',
  component,
  scope,
  singleLine = false,
  children,
}: TableCellProps) {
  return (
    <MuiTableCell
      align={align}
      {...(component !== undefined ? { component } : {})}
      {...(scope !== undefined ? { scope } : {})}
      {...(singleLine ? { sx: { whiteSpace: 'nowrap' } } : {})}
    >
      {children}
    </MuiTableCell>
  );
}
